import { Navigate, Route, Routes } from 'react-router-dom'
import CommandPage from './pages/CommandPage'
import AuditPage from './pages/AuditPage'
import DisabledFunctionsPage from './pages/DisabledFunctionsPage'

const CommandRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/command/functions" replace />} />
      <Route path="/functions" element={<CommandPage />} />
      <Route path="/disabled" element={<DisabledFunctionsPage />} />
      <Route path="/audit" element={<AuditPage />} />
      <Route path="*" element={<Navigate to="/command/functions" replace />} />
    </Routes>
  )
}

export default CommandRoutes
